import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { SiteOwnerUserService } from 'app/_services/site-owner-user.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'admin-all-site-schedule',
  templateUrl: './admin-all-site-schedule.component.html',
})
export class AdminAllSiteScheduleComponent implements OnInit {
  private routeRole: string;

  public siteOwners = [];
  public selectedSiteOwner;
  public siteOwnerId: any;

  public showConfinedSpaceCard: boolean;

  constructor(
    private router: Router,
    private siteOwnerUserService: SiteOwnerUserService,
    globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.getSiteOwnersList();
  }

  private getSiteOwnersList() {
    this.siteOwnerUserService.getAllEnabledSiteOwnersForDropdowns().subscribe((result: any) => {
      this.siteOwners = result.map(item => ({
        label: item.firstName + ' ' + item.lastName,
        value: item.id
      }));

      this.selectedSiteOwner = this.siteOwners.find(s => s.value == environment.WFSO_OWNER_SKYLARK_ID);
    });
  }

  public onSubmit() {
    this.router.navigate(['/' + this.routeRole + '/schedule/', this.selectedSiteOwner.value]);
  }
}
